import React from 'react';
import { IWithReactRouterProps, withReactRouter } from '../../mixins/router/withReactRouter';

import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchGet } from '../../store/fetch';
import { Table, TableBody, TableData, TableHeader, TableHeadRow, TableRow } from '../elements';
import { NullableFormattedDate } from '../utils/NullableFormattedDate';

interface IObjectsListProps extends ITranslateProps, IWithReactRouterProps {
    id?: string;
}

interface IObject {
    id: string;
    name: string;
    location: string;
    surveyId?: string;
    surveryedOn?: Date;
    surveyCondition?: string;
    elementsCount: number;
    surveysCount: number;
}

interface IObjectsListState {
    items: IObject[];
    total: number;
    page: number;
}

const itemsPerPage = 50;

class ObjectsList extends React.Component<IObjectsListProps, IObjectsListState> {
    constructor(props: IObjectsListProps) {
        super(props);

        this.state = {
            items: [],
            total: 0,
            page: 1,
        };
    }

    public override async componentDidMount() {
        await this.getObjects(this.props.id);
    }

    public override render() {
        return (
            <Table hover={true}>
                <TableHeadRow light={true}>
                    <TableHeader>{this.props.t('common.name')} </TableHeader>
                    <TableHeader>{this.props.t('common.location')}</TableHeader>
                    <TableHeader>{this.props.t('object.lastSurveyDate')}</TableHeader>
                </TableHeadRow>
                <TableBody>
                    {this.state.items.map((item) => (
                        <TableRow key={item.id} onClick={() => this.rowClicked(`/objects/${item.id}`)}>
                            <TableData>{item.name}</TableData>
                            <TableData>{item.location}</TableData>
                            <TableData nowrap={true}>
                                <NullableFormattedDate value={item.surveryedOn} />{' '}
                            </TableData>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    private rowClicked(url: string) {
        this.props.navigate(url);
    }

    private async getObjects(companyId?: string) {
        const pageNumber = 1;
        let url = '/api/objects?';
        url += `limit=${itemsPerPage}`;
        url += `&offset=${itemsPerPage * (pageNumber - 1)}`;
        url += `&companyId=${companyId}`;

        const result = await fetchGet(url, {}, [], [403]);
        const items = result.json?.items;
        if (items && items.length > 0) {
            this.setState({ total: result.json?.total, items });
        }
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(withReactRouter(ObjectsList));
